import { Services, joinURLPath, projectName } from '@sigma-frontend-libs/commons'
import Macro from '@sigma-legacy-libs/cache'

import { macroCacheOptions } from '../constants'
import { globalErrorHandler } from '../request/error'
import request from '../request/request'

const Cache = new Macro(macroCacheOptions)
const cachedGet = Cache.wrapWithCache(async (key, id) => {
  return await request.get(joinURLPath(Services.storage, id), undefined, { return: 'meta' })
})

export const getFile = {
  data() {
    return {
      file: undefined,
      fileNotFound: false,
      fileLoading: false
    }
  },

  watch: {
    fileLoading(value) {
      this.$emit('file-loading', value)
    },
    fileNotFound(value) {
      if (value) {
        this.file = undefined
        this.$emit('file-not-found', value)
      }
    }
  },

  methods: {
    async getFile(id) {
      if (!id) {
        return
      }

      try {
        this.fileLoading = true
        const key = [ projectName, Services.storage, 'get', id ].filter(Boolean).join(':')
        const response = await cachedGet(key, id)
        if (response) {
          this.file = response
        }
      } catch (error) {
        if (error?.name === 'EntityNotFoundError') {
          this.fileNotFound = true
        } else {
          globalErrorHandler(error)
        }
      } finally {
        this.fileLoading = false
      }
    }
  }
}
